'use client'

import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from './Header.module.scss'

interface HeaderProps {
	readonly titleLabel: string
	readonly className?: string
}
export function Header({ titleLabel, className }: HeaderProps) {
	return (
		<div
			data-testid='myPurchases.header'
			className={cx(styles.container, className)}
		>
			{titleLabel && (
				<h1 className={cx(text.titleXL, styles.title)}>{titleLabel}</h1>
			)}
		</div>
	)
}
